import { toDate } from "./toDate.js";

/**
 * The {@link isSunday} function options.
 */

/**
 * @name isSunday
 * @category Weekday Helpers
 * @summary Is the given date Sunday?
 *
 * @description
 * Is the given date Sunday?
 *
 * @param date - The date to check
 * @param options - The options object
 *
 * @returns The date is Sunday
 *
 * @example
 * // Is 21 September 2014 Sunday?
 * const result = isSunday(new Date(2014, 8, 21))
 * //=> true
 */
export function isSunday(date, options) {
  return toDate(date, options === null || options === void 0 ? void 0 : options.in).getDay() === 0;
}

// Fallback for modularized imports:
export default isSunday;